import SEGMENT from 'config/segment.singleton';
import SLICK from 'config/slick.singleton';
import { USE_SEGMENT_AND_UPSCOPE } from 'config/use.conf';
import { refreshCognitoUserToken } from 'utils/cognito.util';
import dispatch from 'utils/core/dispatch.util';
import getState from 'utils/core/getState.util';
import logger from 'utils/logger.util';
import asObject from 'utils/objects/asObject.util';

const L = logger('refreshMainToken');

const refreshMainToken = L.wrap('()', async (options) => {
  try {
    const { companyId, salonId, companyName } = asObject(options);
    const id = salonId || companyId;

    const state = getState();
    const { user, userPool, attributes } = asObject(state.cognito);
    const { signInUserSession, username } = asObject(user);
    const sub = attributes?.sub;
    const email = attributes?.email;

    const refreshToken = signInUserSession.refreshToken.getToken();
    const credentials = await refreshCognitoUserToken({ userPool, userName: username, refreshToken, dispatch });

    L.debug('()', { credentials, refreshToken, state });

    // Route through SEGMENT.setCompany - the previous SLICK.segmentAnalytics path was dead code.
    // setCompany's username arg must match the userId used at identify time (Cognito sub).
    // Require BOTH id and companyName: an id-only call would create a nameless ("Unknown")
    // company in Intercom, which was the original cause of the unattached-users symptom.
    if (USE_SEGMENT_AND_UPSCOPE && id && companyName) {
      if (sub) {
        SEGMENT.setCompany({ username: sub, id, name: companyName });
      }
    }
    if (SLICK.segmentAnalytics && (id || companyName)) {
      if (USE_SEGMENT_AND_UPSCOPE) {
        if (email) {
          SLICK.segmentAnalytics.identify(email, { company: { id, name: companyName } });
        } else {
          L.info('()', 'Skipping identify because email is missing:', { id, companyName });
        }
      } else {
        L.info('()', 'Skipping setCompany because sub is missing:', { id, companyName });
      }
    } else if (!USE_SEGMENT_AND_UPSCOPE) {
      L.info('()', 'Due to a flag, skipping on identifying with:', { id, companyName });
    }
  } catch (e) {
    L.warn('()', e);
  }
});

SLICK.token = Object.assign(SLICK.token || {}, { refreshMainToken });

// noinspection JSUnusedGlobalSymbols
export default refreshMainToken;
